export const getAvatarFaceUrl = (avatarPath) => {
    if (!avatarPath) return "/assets/profile_avatar.png";
    const filename = avatarPath.split('/').pop();

    // Manual mapping for edge cases
    if (filename.includes('Woman_2')) return "/assets/mascots/woman_2_face.jpg";
    if (filename === 'man-4.png') return avatarPath;

    let base = filename;
    // Remove extensions
    base = base.replace('.png.png', '').replace('.png', '');

    return `/assets/mascots/${base}_face.png`;
};
